import { shallowEqual, useSelector } from '@xstate/react'

import { DifferenceCard } from './DifferenceCard'
import { CarIcon } from './icons/Car'
import { LeafIcon } from './icons/Leaf'
import { differenceSelector, useNaturalPowerContext } from './NaturalPowerCalculatorProvider'

export function Difference() {
  const services = useNaturalPowerContext()
  const { co2Saved, carsRemoved } = useSelector(services.costInput, differenceSelector, shallowEqual)

  return (
    <div className="flex flex-col w-full gap-4 row-span-full">
      <h4 className="text-xl font-normal text-navy">The differences</h4>
      <div className="grid w-full grid-cols-1 text-sm gap-y-4 md:grid-cols-2 md:gap-x-12 lg:grid-cols-1 lg:text-xs">
        <DifferenceCard
          icon={<LeafIcon key="leaf" className="w-6 h-8" />}
          value={co2Saved}
          label={
            <div>
              tonnes of CO<sub>2</sub> saved
            </div>
          }
          footnoteId={1}
        />
        <DifferenceCard
          icon={<CarIcon key="car" className="h-5 stroke-1 w-9" />}
          value={carsRemoved}
          label={<div>cars removed from the road</div>}
          footnoteId={2}
        />
      </div>
    </div>
  )
}
